import { render, staticRenderFns } from "./GpathQuizDetail.vue?vue&type=template&id=98361b4c"
import script from "./GpathQuizDetail.vue?vue&type=script&lang=js"
export * from "./GpathQuizDetail.vue?vue&type=script&lang=js"
import style0 from "./GpathQuizDetail.vue?vue&type=style&index=0&id=98361b4c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports